<template>
  <q-page
    class="static q-mb-xl"
    dir="ltr"
  >
    <section class="container q-px-md no-rtl">
      <div class="row justify-center">
        <div class="col col-md-8">
          <h1 class="text-black">{{ $t('pages.license_contract.header') }}</h1>
          <div
            v-for="item in $t('pages.license_contract.subitems')"
            :id="item.anchor"
            :key="item.header"
          >
            <h3 class="text-black">
              {{ item.header }}
            </h3>
            <div
              v-for="subitem in item.items"
              :key="subitem"
              class="terms-item q-my-md text-justify"
              v-html="replaceSubitem(subitem)"
            />
          </div>
          <company-details />
        </div>
      </div>
    </section>
  </q-page>
</template>

<script>
import { mapGetters } from 'vuex';

import CompanyDetails from 'components/CompanyDetails';

import storeCountryResidence from 'store/country_residence';
import storeCommissions from 'store/commissions';

export default {
  name: 'LicenseContract',
  components: {
    CompanyDetails,
  },
  preFetch({ currentRoute, store, redirect }) {
    store.registerModule('countryResidence', storeCountryResidence);
    store.registerModule('commissions', storeCommissions);
    return store.dispatch('carrier/fetchCarrier')
      .then(async () => {
        const { locale } = currentRoute.params;
        const { country_residence } = currentRoute.query;
        await Promise.all([
          store.dispatch('commissions/fetchCommissions', {
            country_residence,
          }),
          store.dispatch('countryResidence/fetchCountryResidence', {
            custom_locale: locale === 'ru' ? locale : 'en',
            iso_code:
              store.getters.carrier?.country_residence
              || country_residence,
          }),
        ]);
        if (!store.getters.countryResidence) {
          redirect('/carrier/#/cabinet/settings/carrier_profile');
        }
      });
  },
  data() {
    return {
      linkToPrivacyPolicy: this.$router.resolve({
        name: 'privacy_policy',
        query: this.$route.query,
      }, this.$route),
    };
  },
  computed: {
    ...mapGetters(['countryResidence', 'commissions']),
    matrix() {
      const { commissions, ratings } = this.commissions;
      const items = `
        <tr align="center">
          <td>${this.$t('label.no_rating_new_carriers')}</td>
          <td>${commissions.without_rating}%</td>
          <td> - </td>
          <td> - </td>
          <td> - </td>
        </tr>
      `;

      return ratings.reduce((acc, item, index) => {
        acc += `
          <tr align="center">
            <td>${item}</td>
            ${commissions.with_rating[index].map((el) => `<td>${el}%</td>`).join('')}
          </tr>
        `;
        return acc;
      }, items);
    },
    turnovers() {
      return this.commissions.turnovers.reduce((acc, item) => {
        const { less_than, more_than } = item;
        const text = less_than && more_than
          ? this.$t('label.more_less_than', { less_than, more_than })
          : this.$t(`label.${Object.keys(item)[0]}`, { value: less_than || more_than });
        acc += `<td>${text}</td>`;
        return acc;
      }, '');
    },
  },
  methods: {
    replaceSubitem(item) {
      return item
        .replace('%{country_residence}', this.countryResidence)
        .replace('%{commission_turnovers}', this.turnovers)
        .replace('%{commission_matrix}', this.matrix)
        .replace('%{privacy_policy_url}', this.linkToPrivacyPolicy.href);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .table-responsive {
    hyphens: none;
    overflow-x: auto;
    min-height: .01%;
    margin-bottom: 20px;

    > table {
      width: 100%;
      max-width: 100%;
      border-collapse: collapse;
      border-spacing: 0;

      td {
        border: 1px solid #ddd;
        padding: 10px 15px;
      }
    }

    @media screen and (max-width: 767px) {
      width: 100%;
      overflow-y: hidden;
      border: 1px solid #ddd;
    }
  }
}
</style>
